// extracted by mini-css-extract-plugin
export default {"modify_order_header":"tr","center":"ur","empty":"vr","pending":"wr","referralTitle":"xr","wrapper":"yr","title":"zr","tabs":"Ar","tab":"Br","active":"Cr","btn":"Er","rewards_table":"Fr"};
    if(module.hot) {
      // 1714654883829
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  